if (!customElements.get("known-from-slider")) {
  class KnownFromSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // Respecteert prefers-reduced-motion
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        return;
      }

      const sliderInner = this.querySelector(".slider__inner");
      if (!sliderInner) return;

      // Markeer als geanimeerd zodat de CSS de marquee-animatie activeert
      this.setAttribute("data-animated", "true");

      const sliderContent = Array.from(sliderInner.children);
      if (!sliderContent.length) return;

      // Clone alle items zodat de scroll naadloos kan loopen
      sliderContent.forEach((item) => {
        const duplicatedItem = item.cloneNode(true);
        duplicatedItem.setAttribute("aria-hidden", "true");
        sliderInner.appendChild(duplicatedItem);
      });
    }
  }

  customElements.define("known-from-slider", KnownFromSlider);
}